/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserProfileSummary } from '../../models/user-profile-summary';

export interface LoginAuthentification$Params {
}

export function loginAuthentification(http: HttpClient, rootUrl: string, params?: LoginAuthentification$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileSummary>> {
  const rb = new RequestBuilder(rootUrl, loginAuthentification.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserProfileSummary>;
    })
  );
}

loginAuthentification.PATH = '/login/auth';
